const SESSION_ACTIVITY_STORAGE_KEY = 'captureez:care-source-session-activity:v1';
export const CARE_SOURCE_SESSION_ACTIVITY_EVENT = 'captureez:care-source-session-activity';

const getSessionStorage = () => {
  if (typeof window === 'undefined') return null;
  return window.sessionStorage || null;
};

export const getRememberedCareSourceActivityIds = () => {
  const storage = getSessionStorage();
  if (!storage) return [];

  try {
    const parsed = JSON.parse(storage.getItem(SESSION_ACTIVITY_STORAGE_KEY) || '[]');
    return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
  } catch (error) {
    return [];
  }
};

export const rememberCareSourceActivity = (sourceId = '') => {
  const cleanSourceId = String(sourceId || '').trim();
  const storage = getSessionStorage();

  if (!storage || !cleanSourceId) return;

  const currentIds = getRememberedCareSourceActivityIds();
  if (currentIds.includes(cleanSourceId)) return;

  storage.setItem(
    SESSION_ACTIVITY_STORAGE_KEY,
    JSON.stringify([...currentIds, cleanSourceId])
  );

  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
    window.dispatchEvent(new CustomEvent(CARE_SOURCE_SESSION_ACTIVITY_EVENT, {
      detail: { sourceId: cleanSourceId },
    }));
  }
};

export const rememberCareSourceActivityFromResult = (result = {}) => {
  rememberCareSourceActivity(result.sourceNoteId || result.id || '');
};
